export interface HelpCenter {
  helpCenter: any;
}

export const initialHelpCenterState: HelpCenter = {
  helpCenter: {},
};
